/*
 * @Description: 在空间Z上的边
 * @Author: Xiaohua Zhu
 * @Date: 2021-12-02 19:15:44
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-06-22 09:26:05
 */
import { Vector3 } from '@babylonjs/core/Maths/math';
import BaseLength from './baseLength';
import MeshManage from '../meshManage';
import { SidePlateSequence, BASICTYPE_ENUM, SidePlatePosition, LengthLocation, SidePlateLocation, LengthType, SIDE_PLATE_TYPE, } from '../utils/enum';
import { DEFAULTSEALPLATEDEPTH, VERSION_2_2, TOPFRAME_GROUND, SKIRTINGBOARDCONFIG, FRAMEDEPTH, FRAMECATEGORY, GAP_BETWEEN_WALL_AND_CABINET, DOUBLE_DOOR_REFIRGERATOR_DISTANCE, SINGLE_DOOR_REFIRGERATOR_DISTANCE, DEFAULTSEALPLATEWIDTH, DEFAULTTOPSEALPLATEWIDTH, CALLOUTMARGIN, } from '../utils/kitchenConfig';
import Wall from '../room/wall';
import WindowNode from '../room/window';
import { getFramePositionInfo } from '../utils/templatejsonUtils';
import { checkFrameIsCornerFrames, checkFrameIsHighFrame, getCornerCabinetFrameXZ, getDefaultDoor, } from '../utils/renderUtils';
import { getNewSinkHoleInfo, getOldZSinkHoleInfo } from '../utils/renderSinkUtils';
import RenderVersion from '../utils/renderVersion';
class LengthZ extends BaseLength {
    /**
     * @description: 渲染Z轴侧板
     * @param {*} frameJson 基准模型frame
     * @param {*} sequence 侧板放置的位置（前/后/转角柜）
     * @return {*} { id:该侧板的id, rotation:该侧板所旋转的角度 }
     * @author: Xiaohua Zhu
     */
    renderSidePlate(frameJson, sidePlatesArr, sequence, position) {
        var _a, _b, _c, _d, _e, _f;
        this.sidePlatesArray = sidePlatesArr;
        this.initSidePlatesAndFrames(frameJson, sequence);
        const { sidePlateMeshSize, frameMeshSize, frameCenterPoint, sidePlate, sidePlateID, } = this;
        const { x: sidePlateSizeX, z: sidePlateSizeZ } = sidePlateMeshSize;
        const { x: frameSizeX, z: frameSizeZ } = frameMeshSize;
        const { x: centerPointX, y: centerPointY, z: centerPointZ } = frameCenterPoint;
        const rotation = { x: 0, y: 0, z: 0 };
        const sidePlateScaling = frameSizeX / sidePlateSizeX;
        if (sequence === SidePlateSequence.First && sidePlate) {
            const targetPosition = {
                x: centerPointX,
                y: centerPointY,
                z: centerPointZ,
            };
            rotation.y = Math.PI / 2;
            sidePlate.moveToPosition(targetPosition, rotation);
            sidePlate.meshManage.mesh.scaling.x = sidePlateScaling;
        }
        if (sequence === SidePlateSequence.Last && sidePlate) {
            const targetPosition = {
                x: centerPointX,
                y: centerPointY,
                z: centerPointZ + frameSizeZ / 2 + sidePlateSizeZ / 2,
            };
            sidePlate.moveToPosition(targetPosition, rotation);
            sidePlate.meshManage.mesh.scaling.x = sidePlateScaling;
        }
        // l2上没有柜子，侧板要贴在l1的转角柜上
        if (sequence === SidePlateSequence.Corner && sidePlate) {
            let sidePlateXAfterScaling = 0;
            let sealPlateLength = 0;
            // 转交柜的情况比较特殊 侧板长度为常量 要按顶柜底柜区分
            if (position === SidePlatePosition.Top) {
                sidePlate.meshManage.mesh.scaling.x = FRAMEDEPTH.TOP / sidePlateSizeX;
                sidePlateXAfterScaling = sidePlateSizeX * (FRAMEDEPTH.TOP / sidePlateSizeX);
            }
            if (position === SidePlatePosition.Bottom) {
                sidePlate.meshManage.mesh.scaling.x = FRAMEDEPTH.BOTTOM / sidePlateSizeX;
                sidePlateXAfterScaling = sidePlateSizeX * (FRAMEDEPTH.BOTTOM / sidePlateSizeX);
            }
            // L1侧板贴在转角柜上 如果有补板 需要加上补板的宽度
            if (((_c = (_b = (_a = this.templateJson[position]) === null || _a === void 0 ? void 0 : _a.length2) === null || _b === void 0 ? void 0 : _b.sealPlate) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                sealPlateLength = (_f = new MeshManage(this.scene
                    .getMeshByName((_e = (_d = this.templateJson[position]) === null || _d === void 0 ? void 0 : _d.length2) === null || _e === void 0 ? void 0 : _e.sealPlate[0].id))) === null || _f === void 0 ? void 0 : _f.getModelSize().z;
            }
            const targetPosition = {
                x: centerPointX + (frameSizeX - sidePlateXAfterScaling) / 2,
                y: centerPointY,
                z: centerPointZ + frameSizeZ / 2 + sidePlateSizeZ / 2 + sealPlateLength,
            };
            // L2的侧板 贴到l1转角柜上时要考虑补板的宽度
            sidePlate.moveToPosition(targetPosition, rotation);
        }
        return { id: sidePlateID, rotation };
    }
    getSealPlatesLength(position) {
        var _a, _b, _c, _d, _e, _f;
        let sealPlateLength = 0;
        if (((_c = (_b = (_a = this.templateJson[position]) === null || _a === void 0 ? void 0 : _a.length2) === null || _b === void 0 ? void 0 : _b.sealPlate) === null || _c === void 0 ? void 0 : _c.length) > 0) {
            sealPlateLength = (_f = new MeshManage(this.scene
                .getMeshByName((_e = (_d = this.templateJson[position]) === null || _d === void 0 ? void 0 : _d.length2) === null || _e === void 0 ? void 0 : _e.sealPlate[0].id))) === null || _f === void 0 ? void 0 : _f.getModelSize().z;
        }
        return sealPlateLength;
    }
    getSideSealPlatesLength(position) {
        var _a, _b, _c, _d;
        let sealPlateLength = 0;
        if (((_b = (_a = this.templateJson[position]) === null || _a === void 0 ? void 0 : _a.length2) === null || _b === void 0 ? void 0 : _b.sealPlate)
            && this.getSealPlatePos(this.templateJson, position, position === LengthLocation.Top)
                >= this.templateJson[position].length2.frames.length) {
            sealPlateLength = new MeshManage(this.scene
                .getMeshByName((_d = (_c = this.templateJson[position]) === null || _c === void 0 ? void 0 : _c.length2) === null || _d === void 0 ? void 0 : _d.sealPlate[0].id)).getModelSize().z;
        }
        return sealPlateLength;
    }
    renderSidePlateByLength(sidePlatesArr, position) {
        sidePlatesArr.forEach((sidePlateObj) => {
            if (sidePlateObj === null || sidePlateObj === void 0 ? void 0 : sidePlateObj.frameUUId) {
                /* -----------公共业务逻辑----------- */
                // 处理公共的业务 返回各自的业务所需要的 基准模型尺寸 侧板对象
                const { frameMeshSize: { x: frameSizeX, z: frameSizeZ }, sidePlate, } = this.initSidePlateConfig(sidePlateObj);
                /* -----------公共业务逻辑----------- */
                /* -----------私有数据处理----------- */
                // 侧板模型尺寸
                const { x: sidePlateSizeX, z: sidePlateSizeZ } = sidePlate.meshManage.size;
                // 侧板偏移量 基准模型长度的一半 + 侧板厚度的一半
                let basicDeviation = frameSizeZ / 2 + sidePlateSizeZ / 2;
                // 冰箱顶柜是初始化的时候所以应取反
                // if (sidePlateObj.type === 1) {
                //   basicDeviation = -basicDeviation;
                // }
                // 获取该length的 补板长度 冰箱顶柜侧板不需要加上补板的长度
                const sealPlateLength = sidePlateObj.type === SIDE_PLATE_TYPE.refrigerator
                    ? 0 : this.getSealPlatesLength(position);
                /* -----------私有数据处理----------- */
                /* -----------私有业务逻辑----------- */
                // 侧板尺寸缩放至 需要贴的基准模型的面 的尺寸
                if (sidePlateObj.type === SIDE_PLATE_TYPE.refrigerator) {
                    // 当侧板为冰箱的侧板的时候  这个时候柜子不是已经摆放好的
                    // 是在原点的初始化位置状态  所以处理的逻辑需要单独的修改
                    basicDeviation = frameSizeX / 2 + sidePlateSizeZ / 2;
                    sidePlate.meshManage.mesh.scaling.x = frameSizeZ / sidePlateSizeX;
                }
                else {
                    sidePlate.meshManage.mesh.scaling.x = frameSizeX / sidePlateSizeX;
                }
                /* -----------私有业务逻辑----------- */
                /* -----------侧板分情况的业务逻辑----------- */
                // 根据侧板的location判断 偏移量的正负
                switch (sidePlateObj.location) {
                    // First为靠近坐标轴中心点的位置
                    case SidePlateLocation.First:
                        sidePlate.lengthZSidePlateAction(-basicDeviation);
                        break;
                    // Last为远离坐标轴中心点的位置
                    case SidePlateLocation.Last:
                        if (this.isLTopCabineChanged(position)) {
                            sidePlate.lengthZSidePlateAction(-basicDeviation);
                            break;
                        }
                        sidePlate.lengthZSidePlateAction(basicDeviation
                            + this.getSideSealPlatesLength(position), sidePlateObj.type);
                        // 侧板的type为1的时候是冰箱顶柜的侧板 不能用来计算冰箱的位置
                        if (sidePlateObj.type !== SIDE_PLATE_TYPE.refrigerator) {
                            this.sidePlatePositions[position].position = sidePlate.sidePosition;
                            this.sidePlatePositions[position].sideplateMesh = sidePlate;
                        }
                        else {
                            // 如果是冰箱顶柜的侧板的话 摆好位置之后将其group到cabinet上面 后面调整位置的时候一并调整
                            new MeshManage(this.scene.getMeshByName(sidePlateObj.frameUUId)).addChildModel(sidePlate.meshManage);
                        }
                        break;
                    // Corner为该侧板贴在转角柜的特殊情况
                    case SidePlateLocation.Corner:
                        if (this.isLTopCabineChanged(position)) {
                            sidePlate.cornerSidePlateAction(-basicDeviation - sealPlateLength, position, LengthType.Length2);
                        }
                        else {
                            sidePlate.cornerSidePlateAction(basicDeviation + sealPlateLength, position, LengthType.Length2);
                        }
                        this.sidePlatePositions[position].position = sidePlate.sidePosition;
                        this.sidePlatePositions[position].sideplateMesh = sidePlate;
                        break;
                    default:
                        break;
                }
                /* -----------侧板分情况的业务逻辑----------- */
            }
        });
    }
    /**
     * @description 获取补板位置
     * @param templateJson templateJSon
     * @param type 顶柜或者地柜
     * @returns null：lengthX第一个柜体 其他：哪一个柜体前面
     * @author: Kun Yang
     */
    // eslint-disable-next-line class-methods-use-this
    getSealPlatePos(templateJson, type, isItopType) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const frameLenghth = (_c = (_b = (_a = templateJson[type]) === null || _a === void 0 ? void 0 : _a.length2) === null || _b === void 0 ? void 0 : _b.frames) === null || _c === void 0 ? void 0 : _c.length;
        const otherLength = (_e = (_d = templateJson[type]) === null || _d === void 0 ? void 0 : _d.length2) === null || _e === void 0 ? void 0 : _e.otherSealPlateLength;
        const lastFrame = frameLenghth ? (_g = (_f = templateJson[type]) === null || _f === void 0 ? void 0 : _f.length2) === null || _g === void 0 ? void 0 : _g.frames[frameLenghth - 1]
            : (_j = (_h = templateJson[type]) === null || _h === void 0 ? void 0 : _h.length1) === null || _j === void 0 ? void 0 : _j.frames[0];
        const lastPreFrame = frameLenghth >= 2 ? (_l = (_k = templateJson[type]) === null || _k === void 0 ? void 0 : _k.length2) === null || _l === void 0 ? void 0 : _l.frames[frameLenghth - 2]
            : null;
        // 一字型切换到LengthZ上，默认位置返回处理 1 第一个柜体后面 null 补板在length1第一个柜体后（转角柜情况）
        const defalutPos = isItopType ? 1 : null;
        // 没有柜体 返回null 补板在length1第一个柜体上
        if (!frameLenghth) {
            return defalutPos;
        }
        // 柜体个数是否为1
        if (frameLenghth === 1) {
            // 最后一个是高柜或者转角柜，返回 null
            if (checkFrameIsHighFrame(lastFrame) || checkFrameIsCornerFrames(lastFrame)) {
                return defalutPos;
            }
            // 最后一个是普通柜 （加冰箱可能也会有otherLength）
            if (otherLength) {
                // return frameLenghth;
                return frameLenghth;
            }
            return defalutPos;
        }
        // otherSealPlateLength是否存在 并且柜体个数大于1
        if (otherLength) {
            // 最后一个是高柜，返回倒数第二
            if (checkFrameIsHighFrame(lastFrame)) {
                // 是否是双高柜
                if (lastPreFrame && checkFrameIsHighFrame(lastPreFrame)) {
                    return frameLenghth - 2;
                }
                return frameLenghth - 1;
            }
            // 最后一个是高柜，返回第一个length1第一个（加冰箱可能也会有otherLength）
            return frameLenghth;
        }
        // 默认返回没有柜体
        return defalutPos;
    }
    /**
     *
     * @param {*} lengthSideType lenght1|lenght2|lenght3 哪条边
     * @description 1. 默认判断类型是否为高低柜 并返回位置
     * @returns isHighLowCabinet 边是否存在高低柜情况
     * @returns borderPososition 高低分界处frame的位置
     */
    getHightLowSinkCabinetPos(lengthSideType) {
        var _a, _b, _c, _d, _e, _f, _g;
        const lengthType = lengthSideType || LengthType.Length2;
        const lodaFrames = [
            ...((_b = (_a = this.templateJson) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b[lengthType])
                ? [...(_e = (_d = (_c = this.templateJson) === null || _c === void 0 ? void 0 : _c.bottom) === null || _d === void 0 ? void 0 : _d[lengthType]) === null || _e === void 0 ? void 0 : _e.frames]
                : [],
        ];
        const firstFrameHight = (_g = (_f = lodaFrames[0]) === null || _f === void 0 ? void 0 : _f.componentBasic) === null || _g === void 0 ? void 0 : _g.height;
        if ((lodaFrames === null || lodaFrames === void 0 ? void 0 : lodaFrames.length) === 0) {
            return {
                isHighLowCabinet: false,
                borderPososition: 0,
            };
        }
        const isPos = lodaFrames.findIndex((frame) => { var _a; return ((_a = frame === null || frame === void 0 ? void 0 : frame.componentBasic) === null || _a === void 0 ? void 0 : _a.height) !== firstFrameHight; });
        return {
            isHighLowCabinet: isPos > -1,
            borderPososition: isPos > -1 ? isPos : 0,
        };
    }
    /**
     *
     * @param frame 补板前一个柜体
     * @param lengthType top | bottom
     * @description 计算高低水槽影响的补板缩放尺寸
     * @returns 补板缩放的模型尺寸
     */
    zoomSealPlateY(frame, lengthType) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const { componentBasic: { id } } = frame;
        let defaluFrameData = new MeshManage(this.scene.getMeshByName(id));
        // 补板位置
        const sealPlatePos = this.getSealPlatePos(this.templateJson, lengthType);
        // 1.L型补板位置不在第一个柜子前面 2. length2没有柜体 3. U型length1有转角灶台柜 4. U型(168-228-238)
        const framesLength = (_c = (_b = (_a = this.templateJson) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b.length2) === null || _c === void 0 ? void 0 : _c.frames.length;
        const lengthXSecondFrame = (_g = (_f = (_e = (_d = this.templateJson) === null || _d === void 0 ? void 0 : _d.bottom) === null || _e === void 0 ? void 0 : _e.length1) === null || _f === void 0 ? void 0 : _f.frames) === null || _g === void 0 ? void 0 : _g[1];
        // 改为以length2柜体为缩放
        const scaleYframe = (_j = (_h = this.templateJson) === null || _h === void 0 ? void 0 : _h.bottom) === null || _j === void 0 ? void 0 : _j.length2.frames[0];
        switch (true) {
            case sealPlatePos !== null: // L型lengthZ补板位置不在length1第一个柜子前面
            case framesLength === 0: // L型length2没有柜体
            case checkFrameIsCornerFrames((_m = (_l = (_k = this.templateJson) === null || _k === void 0 ? void 0 : _k.bottom) === null || _l === void 0 ? void 0 : _l.length1) === null || _m === void 0 ? void 0 : _m.frames[0], FRAMECATEGORY.CATEGORY_28): //  U型length1有转角灶台柜
            case (checkFrameIsCornerFrames(lengthXSecondFrame, FRAMECATEGORY.CATEGORY_1)
                && ((_q = (_p = (_o = this.templateJson) === null || _o === void 0 ? void 0 : _o.bottom) === null || _p === void 0 ? void 0 : _p.length1) === null || _q === void 0 ? void 0 : _q.frames.length) === 2): // U型(168-228-238)
                return defaluFrameData.getModelSize().y;
            default:
                if (!checkFrameIsHighFrame(scaleYframe)) {
                    defaluFrameData = new MeshManage(this.scene.getMeshByName(scaleYframe === null || scaleYframe === void 0 ? void 0 : scaleYframe.componentBasic.id));
                }
                return defaluFrameData.getModelSize().y;
        }
    }
    renderSealPlate(sealPlateData, preMeshManage, type, frameData, _this, isItopType) {
        var _a, _b, _c;
        if (!sealPlateData.length) {
            return null;
        }
        let sealPlateMesh;
        this.sealPlateData = sealPlateData; // 记录补板数据
        const { componentBasic: { width, depth, id }, longEdge } = frameData;
        let longLength = longEdge === 1 ? width : depth;
        let scaleX = 0;
        let scaleY = 0;
        let scaleZ = 0;
        let moveX = 0;
        let nextMeshManage = null;
        // 获取柜体门板的厚度
        const defalutDoor = getDefaultDoor(this.templateJson, 'length2', type);
        const defalutDoorMesh = new MeshManage(this.scene.getMeshByName((_a = defalutDoor === null || defalutDoor === void 0 ? void 0 : defalutDoor.componentBasic) === null || _a === void 0 ? void 0 : _a.id));
        const sealPlatePos = this.getSealPlatePos(this.templateJson, type, isItopType);
        // 需要根据位置来判断取门板的z/x null 取z（转角柜情况，门板还未旋转）其它 取x（门板已旋转）
        const drawerDoorDeepSize = ((_b = defalutDoorMesh === null || defalutDoorMesh === void 0 ? void 0 : defalutDoorMesh.getModelSize()) === null || _b === void 0 ? void 0 : _b[sealPlatePos ? 'x' : 'z']) || DEFAULTSEALPLATEDEPTH;
        const defaluFrameData = new MeshManage(this.scene.getMeshByName(id));
        this.initSealPlate(sealPlateData, _this);
        switch (type) {
            case BASICTYPE_ENUM.top:
                this.sealPlateData = sealPlateData; // 记录补板数据
                sealPlateMesh = new MeshManage(this.scene.getMeshByName(sealPlateData[0].id));
                sealPlateData.forEach((plate, plateInx) => {
                    var _a, _b, _c;
                    switch (plateInx) {
                        case 0:
                            // 相同补板，默认取第一块数据保存实例
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            // 缩放
                            scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = FRAMEDEPTH.TOP / sealPlateMesh.getModelSize().y;
                            (_a = this.sealPlate) === null || _a === void 0 ? void 0 : _a.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            // 旋转
                            this.setMeshRotate(new Vector3(Math.PI / 2, Math.PI / 2, 0), sealPlateMesh);
                            // 旋转后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            longLength = depth;
                            moveX = ((preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5)
                                / (longLength / 10)) * DEFAULTTOPSEALPLATEWIDTH;
                            sealPlateMesh.setModelPosition({
                                x: moveX,
                                y: TOPFRAME_GROUND(this.templateJson) - sealPlateMesh.getModelSize().y * 0.5,
                                z: preMeshManage.mesh.position.z + preMeshManage.getModelSize().z * 0.5
                                    + sealPlateMesh.getModelSize().z * 0.5,
                            });
                            break;
                        case 1:
                            // 相同补板，默认取第一块数据保存实例
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            // 缩放
                            scaleX = (plate.width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = defaluFrameData.getModelSize().y / sealPlateMesh.getModelSize().y;
                            scaleZ = drawerDoorDeepSize / sealPlateMesh.getModelSize().z;
                            (_b = this.sealPlate) === null || _b === void 0 ? void 0 : _b.setSealPlatesScale(sealPlateMesh, scaleX, scaleY, scaleZ);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            // 旋转 并添加到旋转管理器
                            this.setMeshRotate(new Vector3(0, Math.PI / 2, 0), sealPlateMesh);
                            // eslint-disable-next-line no-param-reassign
                            _this.rotationMeshes[plate.id] = new Vector3(0, Math.PI / 2, 0);
                            // 旋转后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            longLength = depth;
                            moveX = ((preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5)
                                / (longLength / 10)) * DEFAULTTOPSEALPLATEWIDTH;
                            sealPlateMesh.setModelPosition({
                                x: moveX - sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(this.templateJson) - sealPlateMesh.getModelSize().y,
                                z: preMeshManage.mesh.position.z + preMeshManage.getModelSize().z * 0.5
                                    + sealPlateMesh.getModelSize().z * 0.5,
                            });
                            // 顶柜的补板，需要返回正面的mesh 补板后面柜体需要移动
                            nextMeshManage = sealPlateMesh;
                            break;
                        case 2:
                            // 相同补板，默认取第一块数据保存实例
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            // 缩放
                            scaleX = (plate.width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = FRAMEDEPTH.TOP / sealPlateMesh.getModelSize().y;
                            (_c = this.sealPlate) === null || _c === void 0 ? void 0 : _c.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            // 旋转
                            this.setMeshRotate(new Vector3(Math.PI / 2, Math.PI / 2, 0), sealPlateMesh);
                            // 旋转后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            longLength = depth;
                            moveX = ((preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5)
                                / (longLength / 10)) * DEFAULTTOPSEALPLATEWIDTH;
                            sealPlateMesh.setModelPosition({
                                x: moveX,
                                y: TOPFRAME_GROUND(this.templateJson) - preMeshManage.getModelSize().y
                                    + sealPlateMesh.getModelSize().y * 0.5,
                                z: preMeshManage.mesh.position.z + preMeshManage.getModelSize().z * 0.5
                                    + sealPlateMesh.getModelSize().z * 0.5,
                            });
                            break;
                        default:
                            break;
                    }
                });
                return nextMeshManage;
                break;
            case BASICTYPE_ENUM.bottom:
                // 相同补板，默认取第一块数据保存实例
                sealPlateMesh = new MeshManage(this.scene.getMeshByName(sealPlateData[0].id));
                // 缩放
                scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                scaleY = this.zoomSealPlateY(frameData, type) / sealPlateMesh.getModelSize().y;
                scaleZ = drawerDoorDeepSize / sealPlateMesh.getModelSize().z;
                (_c = this.sealPlate) === null || _c === void 0 ? void 0 : _c.setSealPlatesScale(sealPlateMesh, scaleX, scaleY, scaleZ);
                // 旋转 并加入旋转管理器
                this.setMeshRotate(new Vector3(0, Math.PI / 2, 0), sealPlateMesh);
                // eslint-disable-next-line no-param-reassign
                _this.rotationMeshes[sealPlateData[0].id] = new Vector3(0, Math.PI / 2, 0);
                // 旋转后需要重新获取尺寸信息
                sealPlateMesh = new MeshManage(this.scene.getMeshByName(sealPlateData[0].id));
                // eslint-disable-next-line no-case-declarations
                const lastMoveX = ((-preMeshManage.getModelSize().x) / (longLength / 10)) * DEFAULTSEALPLATEWIDTH;
                sealPlateMesh.setModelPosition({
                    x: lastMoveX - sealPlateMesh.getModelSize().x * 0.5,
                    y: SKIRTINGBOARDCONFIG.HEIGHT,
                    // z: preMeshManage.mesh.position.z + preMeshManage.getModelSize().z * 0.5
                    //    + sealPlateMesh.getModelSize().z,
                    z: preMeshManage.mesh.position.z + preMeshManage.getModelSize().z * 0.5
                        + sealPlateMesh.getModelSize().z * 0.5,
                });
                return sealPlateMesh;
                break;
            default:
                return null;
                break;
        }
    }
    // eslint-disable-next-line max-len
    getSinkHolePosition(sinkCabinetId, sinkId, topPanelPositionY, cornerCabinetDirection, sinkInfo) {
        var _a;
        const sinkMesh = this.scene.getMeshByName(sinkId); // 定义水槽模型
        const sinkFrameMesh = this.scene.getMeshByName(sinkCabinetId); // 定义水槽所在柜子的整体模型
        let holePosition;
        let holeSize;
        if (RenderVersion.checkOldRenderVersion(((_a = this === null || this === void 0 ? void 0 : this.templateJson) === null || _a === void 0 ? void 0 : _a.version) || '2.1', VERSION_2_2)) {
            holePosition = getOldZSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection).holePosition;
            holeSize = getOldZSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection).holeSize;
        }
        else {
            holePosition = getNewSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection, sinkInfo, 'z').holePosition;
            holeSize = getNewSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection, sinkInfo, 'z').holeSize;
        }
        return { holePosition, holeSize };
    }
    // 获取边长
    getSideLength(minimum = 0) {
        var _a, _b;
        const { lastFrame, location } = this.getLastFrame();
        let length;
        if (lastFrame) {
            const meshManage = new MeshManage(this.scene.getMeshByName(lastFrame.componentBasic.id));
            length = meshManage.getModelSize().z / 2 + Math.abs(meshManage.mesh.position.z) + this.getRLength();
            // 如果是U_S柜型 且l2存在最后一个柜子的话 这个时候需要添加上l3的短柜体的柜深
            if (((_b = (_a = this === null || this === void 0 ? void 0 : this.templateJson) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b.type) === 'U_S') {
                length += FRAMEDEPTH.USBOTTOM;
            }
        }
        else {
            length = this.templateJson[location][this.lengthType].length * 0.01;
        }
        if ((lastFrame === null || lastFrame === void 0 ? void 0 : lastFrame.categoryId) === FRAMECATEGORY.CATEGORY_39) {
            if ((lastFrame === null || lastFrame === void 0 ? void 0 : lastFrame.width) === 100) {
                length += DOUBLE_DOOR_REFIRGERATOR_DISTANCE;
            }
            else {
                length += SINGLE_DOOR_REFIRGERATOR_DISTANCE;
            }
        }
        return Math.max(length, minimum);
    }
    createWall(width) {
        const wallNode = new Wall(this.scene);
        const sideLength = (width !== null && width !== void 0 ? width : this.getSideLength());
        const fromPoint = { x: 2 * GAP_BETWEEN_WALL_AND_CABINET, y: 0, z: 0 };
        const toPoint = { x: -sideLength - 2 * GAP_BETWEEN_WALL_AND_CABINET, y: 0, z: 0 };
        const wallSegmentNode = {
            toPoint,
            fromPoint,
            wallHeight: TOPFRAME_GROUND(this.templateJson),
            name: 'lengthZ',
        };
        wallNode.createWall(wallSegmentNode, { x: 0, y: -Math.PI / 2, z: 0 }, { x: 0, y: 0, z: sideLength });
        this.wallNode = wallNode;
    }
    createWindow(frame, window) {
        var _a, _b, _c, _d;
        if (!frame || !((_a = window === null || window === void 0 ? void 0 : window.componentBasic) === null || _a === void 0 ? void 0 : _a.modelUrl)) {
            return;
        }
        const windowNode = new WindowNode(this.scene, this.templateJson);
        const { width: windowWidth, height: windowHeight } = window.componentBasic;
        const frameMeshManage = new MeshManage(this.scene.getMeshByName(frame.componentBasic.id));
        const { position } = frameMeshManage.mesh;
        let windowPosition = position;
        // 判断柜体是不是带水槽的转角柜  如果是带水槽的转角柜位置根据水槽的中心点来判断
        // Z轴上面的水槽是旋转之后的所以在判断尺寸的时候需要旋转x、z
        if (frame.categoryId === FRAMECATEGORY.CATEGORY_27) {
            const { cornerCabinetDirection } = getFramePositionInfo(this.templateJson, 'sink');
            const sinkMesh = new MeshManage(this.scene.getMeshByName(((_c = (_b = frame.sink) === null || _b === void 0 ? void 0 : _b.componentBasic) === null || _c === void 0 ? void 0 : _c.id) || ''));
            windowPosition = getCornerCabinetFrameXZ(position, frameMeshManage.getModelSize(), {
                x: sinkMesh.getModelSize().z,
                y: sinkMesh.getModelSize().y,
                z: sinkMesh.getModelSize().x,
            }, cornerCabinetDirection, `length${frame.longEdge}`, 'ventilator');
        }
        const windowSegmentNode = {
            width: windowWidth / 1000,
            height: windowHeight / 1000,
            name: 'lengthZWindow',
            position: { x: -0.01, y: TOPFRAME_GROUND(this.templateJson) - windowHeight / 1000 / 2, z: windowPosition.z },
            textureImage: (_d = window === null || window === void 0 ? void 0 : window.componentBasic) === null || _d === void 0 ? void 0 : _d.modelUrl,
            // textureImage: 'https://kitchen-asset-dev.oss-cn-shanghai.aliyuncs.com/kitchen/model/43211640311596.jpg',
        };
        windowNode.createWindow(windowSegmentNode, { x: 0, y: -Math.PI * 1.5, z: 0 });
        this.windowNode = windowNode;
    }
    getFramesCalloutLine(position, title) {
        // 柜体顶端距离地面的高度 用于标线的高度
        const topToGround = this.getCalloutLineTopToGround(position);
        // 获取边的长度
        const { length, lengthValue } = this.getLengthByAddAllFrames(position);
        // 获取边的第一个柜子和最后一个柜子的高度
        const { startHeight, endHeight } = this.getCalloutLineHeightLength();
        // 获取柜深
        const calloutLineDepthLength = this.getCalloutLineDepthLength();
        /* -----------长度标线----------- */
        // 长度标线的起点
        const startPoint = { x: 0, y: topToGround + CALLOUTMARGIN, z: 0 };
        // 长度标线的终点
        const endPoint = { x: 0, y: topToGround + CALLOUTMARGIN, z: length };
        // 长度标线
        const lengthLine = { startPoint, endPoint };
        /* -----------长度标线----------- */
        /* -----------高度标线1----------- */
        // 长度标线起点的高度标线起点
        const startHeightStartPoint = {
            x: startPoint.x,
            y: this.getCalloutLineHeightHeight(),
            z: startPoint.z - CALLOUTMARGIN,
        };
        // 长度标线起点的高度标线终点
        const startHeightEndPoint = {
            x: startHeightStartPoint.x,
            y: startHeightStartPoint.y + startHeight,
            z: startHeightStartPoint.z,
        };
        // 长度标线起点的高度标线
        const startHeightLine = {
            startPoint: startHeightStartPoint,
            endPoint: startHeightEndPoint,
        };
        /* -----------高度标线1----------- */
        /* -----------高度标线2----------- */
        const endHeightStartPoint = {
            x: endPoint.x,
            y: this.getCalloutLineHeightHeight(),
            z: endPoint.z + CALLOUTMARGIN,
        };
        const endHeightEndPoint = {
            x: endHeightStartPoint.x,
            y: endHeightStartPoint.y + endHeight,
            z: endHeightStartPoint.z,
        };
        const endHeightLine = {
            startPoint: endHeightStartPoint,
            endPoint: endHeightEndPoint,
        };
        /* -----------高度标线2----------- */
        /* -----------深度标线1----------- */
        // 长度标线起点的深度标线起点（长度标线起点的高度标线起点）
        const startDepthStartPoint = startHeightStartPoint;
        // 长度标线终点的深度标线起点
        const startDepthEndPoint = {
            x: startDepthStartPoint.x - calloutLineDepthLength,
            y: startDepthStartPoint.y,
            z: startDepthStartPoint.z,
        };
        // 长度标线终点的深度标线
        const startDepthLine = {
            startPoint: startDepthStartPoint,
            endPoint: startDepthEndPoint,
        };
        /* -----------深度标线2----------- */
        /* -----------深度标线2----------- */
        // 长度标线终点的深度标线起点（长度标线终点的高度标线起点）
        const endDepthStartPoint = endHeightStartPoint;
        // 长度标线终点的深度标线起点
        const endDepthEndPoint = {
            x: endDepthStartPoint.x - calloutLineDepthLength,
            y: endDepthStartPoint.y,
            z: endDepthStartPoint.z,
        };
        // 长度标线终点的深度标线
        const endDepthLine = {
            startPoint: endDepthStartPoint,
            endPoint: endDepthEndPoint,
        };
        /* -----------深度标线2----------- */
        const calloutLinesArr = [];
        calloutLinesArr.push({
            type: 'length', line: lengthLine, value: lengthValue, title: title || 'L2',
        });
        calloutLinesArr.push({
            type: 'startHeight', line: startHeightLine, value: startHeight, isHeight: true,
        });
        calloutLinesArr.push({
            type: 'endHeight', line: endHeightLine, value: endHeight, isHeight: true,
        });
        calloutLinesArr.push({
            type: 'startDepth', line: startDepthLine, value: calloutLineDepthLength,
        });
        calloutLinesArr.push({
            type: 'endDepth', line: endDepthLine, value: calloutLineDepthLength,
        });
        return calloutLinesArr;
    }
}
export default LengthZ;
